// extracted by mini-css-extract-plugin
export default {"root":"LockAvailabilityHolidayForm_root__bloCB"};